import * as React from 'react';
import { Button, Modal, Space, TextBody, TextHeading } from '@ally/metronome-ui';
const ModalContent = ({ navigateToLogin, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { mb: "md" },
            React.createElement(TextHeading, { tag: "h1", size: "md", tabIndex: -1 }, "Incorrect Code")),
        React.createElement(Space, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "md" }, "You've reached the maximum number of entry attempts. Try again later.")),
        React.createElement(Button, { variant: "primary", text: "Ok", onClick: navigateToLogin })));
};
export const MaxOTPCodeAttemptsModal = ({ navigateToLogin, }) => {
    // we want the user to go boot the user to login whether they click ok or dismiss modal
    const onClose = (isOpen) => {
        if (!isOpen)
            navigateToLogin();
    };
    return (React.createElement(Modal, { content: React.createElement(ModalContent, { navigateToLogin: navigateToLogin }), initialOpen: true, onOpenChange: onClose }));
};
//# sourceMappingURL=MaxOTPCodeAttemptsModal.js.map